var avatarImage = 'fx_e395032e_cgja1i0';

export { avatarImage };
//# sourceMappingURL=image.vanilla.mjs.map
